import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { DomainURL, DomainURLUpdatePayload } from '@core/models/domain-url.model';
import { SKIP_ERROR_INTERCEPTOR_HEADER } from '@utils/constants';

export interface DomainURLDuplicateConflict {
  id: number;
  region?: string;
  domains: string;
  priority_type_name: string;
  domain_type_name: string;
  duplicate_domains: string[];
}

export interface DomainURLCheckDuplicatePayload {
  id?: number;
  settings_currency_id: number;
  priority_type?: any[];
  priority_data?: DomainURLUpdatePayload['priority_data'];
}

@Injectable()
export class DomainURLDataService {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(private http: HttpClient) { }

  getAll(): Observable<DomainURL[]> {
    return this.http.get<ApiResponse>('/domains').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<DomainURL[]>{
    return this.http.get<ApiResponse>(`/domains${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getById(id: number): Observable<DomainURL>{
    return this.http.get<ApiResponse>(`/domains/${id}`).pipe(
      map(res => res.data)
    );
  }

  checkDuplicates(data: DomainURLCheckDuplicatePayload) {
    const headers = {
      [SKIP_ERROR_INTERCEPTOR_HEADER]: 'true'
    };

    return this.http.post<ApiResponse>('/domains/check-duplicates', data, { headers }).pipe(
      map(res => res.data?.conflicts || [])
    );
  }

  update(data: DomainURLUpdatePayload) {
    return this.http.put<ApiResponse>(`/domains`, data).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
